import { useIntl } from '@capsicum/common';
import { BaseCheckboxInput, GenericDrawer, Text } from '@capsicum/common-web';
import { useState } from 'react';
import styled from 'styled-components';

export type NCRegistrationConfirmDrawerProps = {
	closeModal: () => void;
	onConfirm: () => void;
	testID: string;
};

export const NCRegistrationConfirmDrawer = ({ closeModal, onConfirm, testID }: NCRegistrationConfirmDrawerProps) => {
	const { $t } = useIntl();

	// Comment: Unified the state for the checkboxes in order to not have multiple states & handlers
	const [{ isConfirmFundsLost, isConfirmSecuredKit, isConfirmSocios }, setIsConfirm] = useState({
		isConfirmFundsLost: false,
		isConfirmSecuredKit: false,
		isConfirmSocios: false
	});

	const handleCheckboxChange = (name: 'isConfirmFundsLost' | 'isConfirmSecuredKit' | 'isConfirmSocios') => {
		setIsConfirm(prevState => ({
			...prevState,
			[name]: !prevState[name]
		}));
	};

	const NCRegistrationConfirmDrawerData = {
		buttonDisabled: !isConfirmFundsLost || !isConfirmSecuredKit || !isConfirmSocios,
		buttonText: $t('ncOnboarding.recoveryKit.modal.buttonIUnderstand'),
		checkboxFundsLost: $t('ncOnboarding.recoveryKit.modal.checkboxFundsLost'),
		checkboxSecuredKit: $t('ncOnboarding.recoveryKit.modal.checkboxSecuredKit'),
		checkboxSocios: $t('ncOnboarding.recoveryKit.modal.checkboxSocios'),
		isButtonOnRow: false,
		onButtonPress: onConfirm,
		onSecondaryActionOnButtonPress: closeModal,
		secondaryActionButtonText: $t('ncOnboarding.recoveryKit.modal.buttonView'),
		testID: testID,
		title: $t('ncOnboarding.recoveryKit.modal.title'),
		warning: true
	};

	return (
		<GenericDrawer {...NCRegistrationConfirmDrawerData}>
			<S.FormContainer>
				<S.CheckboxesContainer>
					<BaseCheckboxInput
						testID="ncRegistration-confirmFundsLost-checkbox"
						onChange={() => handleCheckboxChange('isConfirmFundsLost')}
					>
						<S.CheckboxInputText variant="text3">
							{NCRegistrationConfirmDrawerData.checkboxFundsLost}
						</S.CheckboxInputText>
					</BaseCheckboxInput>
					<BaseCheckboxInput
						testID="ncRegistration-confirmSocios-checkbox"
						onChange={() => handleCheckboxChange('isConfirmSocios')}
					>
						<S.CheckboxInputText variant="text3">
							{NCRegistrationConfirmDrawerData.checkboxSocios}
						</S.CheckboxInputText>
					</BaseCheckboxInput>
					<BaseCheckboxInput
						testID="ncRegistration-confirmSecuredKit-checkbox"
						onChange={() => handleCheckboxChange('isConfirmSecuredKit')}
					>
						<S.CheckboxInputText variant="text3">
							{NCRegistrationConfirmDrawerData.checkboxSecuredKit}
						</S.CheckboxInputText>
					</BaseCheckboxInput>
				</S.CheckboxesContainer>
			</S.FormContainer>
		</GenericDrawer>
	);
};

namespace S {
	export const FormContainer = styled.div`
		display: flex;
		flex-direction: column;
		justify-content: center;
		align-items: center;
		padding: ${({ theme }) => `${theme.spacings.medium} 0`};
		width: 100%;
	`;

	export const CheckboxesContainer = styled.div`
		display: flex;
		flex-direction: column;
		row-gap: ${({ theme }) => theme.spacings.small};

		padding: ${({ theme }) => `0 ${theme.spacings.xlarge}`};
	`;

	export const CheckboxInputText = styled(Text)`
		color: ${({ theme }) => theme.colors.text.main};
	`;
}
